import { render, staticRenderFns } from "./BankTransactionStatisticsSchool.vue?vue&type=template&id=4a6dbad6&scoped=true"
import script from "./BankTransactionStatisticsSchool.vue?vue&type=script&lang=js"
export * from "./BankTransactionStatisticsSchool.vue?vue&type=script&lang=js"
import style0 from "./BankTransactionStatisticsSchool.vue?vue&type=style&index=0&id=4a6dbad6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6dbad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6dbad6')) {
      api.createRecord('4a6dbad6', component.options)
    } else {
      api.reload('4a6dbad6', component.options)
    }
    module.hot.accept("./BankTransactionStatisticsSchool.vue?vue&type=template&id=4a6dbad6&scoped=true", function () {
      api.rerender('4a6dbad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/BankTransactionStatisticsSchool.vue"
export default component.exports